module.exports = "<div class=\"buttons text-right\"> <button class=\"btn btn-info\" ng-if=jdroPerms.UPDATE ng-click=edit(item) title=\"{{ 'jdro_common.edit' | translate }}\"> <i class=\"fa fa-pencil-square-o\"></i> </button> <button class=\"btn btn-warning\" ng-click=remove(item) ng-if=jdroPerms.DELETE title=\"{{ 'jdro_common.delete' | translate }}\"> <i class=\"fa fa-trash-o\"></i> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupAction.html
// module id = 375
// module chunks = 0